import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';

/** What a single button in the dialog looks like */
export interface DialogButton {
  /** Button text */
  label: string;
  /** Mat-color palette: 'primary' | 'accent' | 'warn' (optional) */
  color?: ThemePalette;
  /** Value to emit/return when the button is clicked (optional) */
  value?: any;
}

/** Data object passed in when the dialog is opened */
export interface DialogData {
  title: string;
  message: string;
  /** Array of buttons (defaults supplied if omitted) */
  buttons?: DialogButton[];
}

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.css']
})
export class DialogBoxComponent implements OnInit {
  title!: string;
  message!: string;
  buttons: DialogButton[] = [];

  constructor(
    private readonly dialogRef: MatDialogRef<DialogBoxComponent, any>,
    @Inject(MAT_DIALOG_DATA) private readonly data: DialogData
  ) {}

  ngOnInit(): void {
    const { title, message, buttons } = this.data;
    console.log('this.data ===> ', this.data);
    this.title   = title;
    this.message = message;
    this.buttons = (buttons?.length > 0)
      ? buttons
      : [
          { label: 'OK',     value: true,  color: 'primary' },
          { label: 'Cancel', value: false, color: 'accent' }
        ];
    console.log('this.buttons ===> ', this.buttons);    
  }

  lFN_OnButtonClick(result?: any): void {
    this.dialogRef.close(result);
  }
}
